export const UPDATE_HUB_CONNECTION = "UPDATE_HUB_CONNECTION";